import { i18n } from '@lingui/core';

export interface NewBinderDeliveryParams extends Record<string, string | undefined> {
  projectId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/new-binder-delivery`;
export const TITLE = i18n._('New Binder Delivery');
